import dynamic from 'next/dynamic'
import { useEffect, useState, useRef } from 'react'
import BookButtonStatic from './book-button-static.jsx'

// Dynamically import to avoid pulling framer-motion into the initial bundle
const BookButtonMotion = dynamic(() => import('./book-button-motion.js'), {
  ssr: false,
  loading: () => null,
})

const BookButton = (props) => {
  const [isDesktop, setIsDesktop] = useState(false)
  const [useMotion, setUseMotion] = useState(false)
  const [motionLoaded, setMotionLoaded] = useState(false)
  const hasInteracted = useRef(false)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia('(min-width: 1280px)')
    const update = () => setIsDesktop(mq.matches)
    update()
    mq.addEventListener ? mq.addEventListener('change', update) : mq.addListener(update)
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', update) : mq.removeListener(update)
    }
  }, [])

  // Handle user interaction on desktop to load motion version
  useEffect(() => {
    if (!isDesktop || hasInteracted.current) return

    const handleUserInteraction = () => {
      if (hasInteracted.current) return
      hasInteracted.current = true
      
      // Preload the motion component
      import('./book-button-motion.js').then(() => {
        setMotionLoaded(true)
        // Small delay to ensure smooth transition
        setTimeout(() => {
          setUseMotion(true)
        }, 50)
      })
    }

    // Listen for mouse movement to detect user interaction
    document.addEventListener('mousemove', handleUserInteraction, { once: true, passive: true })
    
    return () => {
      document.removeEventListener('mousemove', handleUserInteraction)
    }
  }, [isDesktop])

  // On mobile, always use static
  if (!isDesktop) return <BookButtonStatic {...props} />
  
  // On desktop, use motion version if loaded and user has interacted
  if (useMotion && motionLoaded) return <BookButtonMotion {...props} />
  
  // Default to static version
  return <BookButtonStatic {...props} />
}

export default BookButton
